import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/dedupe';
import './stylesheets/ActionMenuItem.scss';

export default function ActionMenuItem(props) {
  const { title, onClick, href, className, children } = props;
  const classes = {
    loc: true,
    'action-menu-item': true,
    'non-interactable': (href == null && onClick == null)
  };
  const flattenedClassNames = classNames(classes, className);

  const innerContent = (React.Children.count(children) > 0) ? children : title;

  if (href) {
    return <a className={flattenedClassNames} href={href} onClick={onClick}>{ innerContent }</a>;
  }

  // FIXME: more onClick shenanigans
  // eslint-disable-next-line
  return <div className={flattenedClassNames} onClick={onClick}>{ innerContent }</div>;
}

// Pass title or children. Title is ignored if children are present.
ActionMenuItem.propTypes = {
  /** Action menu item title */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** Action menu item click action */
  onClick: PropTypes.func,
  /** returns an <a> tag if specified with the given href */
  href: PropTypes.string,
  /** Additional className to customize style */
  className: PropTypes.string,
  /** Children to transclude */
  children: PropTypes.node
};



// WEBPACK FOOTER //
// ./node_modules/@localytics/loc-components/lib/ActionMenuItem.jsx